import { render, staticRenderFns } from "./ModuleStepListStepActivatorPickStepRequirements.vue?vue&type=template&id=52d5809c&"
import script from "./ModuleStepListStepActivatorPickStepRequirements.vue?vue&type=script&lang=ts&"
export * from "./ModuleStepListStepActivatorPickStepRequirements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
